import React, { useEffect, useRef, useState } from "react";
import styled, { withTheme } from "styled-components";

const StyledInput = styled.input`
  border-bottom: 2px solid ${(props) => props.theme?.darkPurple} !important;
  &.invalid {
    border-bottom: 2px solid ${(props) => props.theme?.cardinal} !important;
  }
  &.shake {
    animation: shake 0.3s ease-in-out;
  }
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-5px);
    }
    50% {
      transform: translateX(5px);
    }
    75% {
      transform: translateX(-5px);
    }
    100% {
      transform: translateX(0);
    }
  }
`;

export const PasswordInput = (props) => {
  const {
    field,
    margin,
    inputError,
    placeholder,
    value,
    onChange,
    onBlur,
    autoFocus,
  } = props;

  const innerRef = useRef();
  const [inputValue, setInputValue] = useState(value || "");
  const [isMaxLength, setIsMaxLength] = useState(false);

  useEffect(() => {
    if (autoFocus) {
      // this fix the issue with input autofocus when opening a modal
      setTimeout(() => innerRef.current?.focus(), 1);
    }
  }, []);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (newValue.length > 50) {
      setIsMaxLength(true);
      setTimeout(() => setIsMaxLength(false), 300); // Reset the shake effect
    } else {
      setIsMaxLength(false);
      setInputValue(newValue);
      onChange(e);
    }
  };

  return (
    <StyledInput
      data-testid={`password-input${field ? "-" + field : ""}`}
      type="password"
      className={`
              form-control
              ${margin ? margin : ""}
              ${inputError ? "shake" : ""}
              ${isMaxLength ? "shake" : ""}
          `}
      placeholder={placeholder}
      value={inputValue}
      onChange={handleInputChange}
      onBlur={onBlur}
      spellCheck={false}
      ref={innerRef}
    />
  );
};

export default withTheme(PasswordInput);
